/**
 * Static ISO country list for the signup country picker (value = ISO code).
 * Reference data — copied verbatim from the legacy app (frontend/src/libs/data_country.ts);
 * the backend doesn't serve a countries endpoint for signup.
 */
export interface Country {
  country_id: number;
  country_code: string;
  country_name: string;
}

/** Look up a country name by ISO code (case-insensitive); returns the code if
 * unknown. */
export function countryName(code: string): string {
  if (!code) return "";
  const match = countries.find(
    (c) => c.country_code.toLowerCase() === code.toLowerCase(),
  );
  return match?.country_name ?? code;
}

export const countries: Country[] = [
  {
    country_id: 1,
    country_code: "AF",
    country_name: "Afghanistan",
  },
  {
    country_id: 2,
    country_code: "AX",
    country_name: "Aland Islands",
  },
  {
    country_id: 3,
    country_code: "AL",
    country_name: "Albania",
  },
  {
    country_id: 4,
    country_code: "DZ",
    country_name: "Algeria",
  },
  {
    country_id: 5,
    country_code: "AS",
    country_name: "American Samoa",
  },
  {
    country_id: 6,
    country_code: "AD",
    country_name: "Andorra",
  },
  {
    country_id: 7,
    country_code: "AO",
    country_name: "Angola",
  },
  {
    country_id: 8,
    country_code: "AI",
    country_name: "Anguilla",
  },
  {
    country_id: 9,
    country_code: "AG",
    country_name: "Antigua and Barbuda",
  },
  {
    country_id: 10,
    country_code: "AR",
    country_name: "Argentina",
  },
  {
    country_id: 11,
    country_code: "AM",
    country_name: "Armenia",
  },
  {
    country_id: 12,
    country_code: "AW",
    country_name: "Aruba",
  },
  {
    country_id: 13,
    country_code: "AU",
    country_name: "Australia",
  },
  {
    country_id: 14,
    country_code: "AT",
    country_name: "Austria",
  },
  {
    country_id: 15,
    country_code: "AZ",
    country_name: "Azerbaijan",
  },
  {
    country_id: 16,
    country_code: "BS",
    country_name: "Bahamas",
  },
  {
    country_id: 17,
    country_code: "BH",
    country_name: "Bahrain",
  },
  {
    country_id: 18,
    country_code: "BD",
    country_name: "Bangladesh",
  },
  {
    country_id: 19,
    country_code: "BB",
    country_name: "Barbados",
  },
  {
    country_id: 20,
    country_code: "BY",
    country_name: "Belarus",
  },
  {
    country_id: 21,
    country_code: "BE",
    country_name: "Belgium",
  },
  {
    country_id: 22,
    country_code: "BZ",
    country_name: "Belize",
  },
  {
    country_id: 23,
    country_code: "BJ",
    country_name: "Benin",
  },
  {
    country_id: 24,
    country_code: "BM",
    country_name: "Bermuda",
  },
  {
    country_id: 25,
    country_code: "BT",
    country_name: "Bhutan",
  },
  {
    country_id: 26,
    country_code: "BO",
    country_name: "Bolivia",
  },
  {
    country_id: 27,
    country_code: "BA",
    country_name: "Bosnia and Herzegovina",
  },
  {
    country_id: 28,
    country_code: "BW",
    country_name: "Botswana",
  },
  {
    country_id: 29,
    country_code: "BV",
    country_name: "Bouvet Island",
  },
  {
    country_id: 30,
    country_code: "BR",
    country_name: "Brazil",
  },
  {
    country_id: 31,
    country_code: "IO",
    country_name: "British Indian Ocean Territory",
  },
  {
    country_id: 32,
    country_code: "BN",
    country_name: "Brunei Darussalam",
  },
  {
    country_id: 33,
    country_code: "BG",
    country_name: "Bulgaria",
  },
  {
    country_id: 34,
    country_code: "BF",
    country_name: "Burkina Faso",
  },
  {
    country_id: 35,
    country_code: "BI",
    country_name: "Burundi",
  },
  {
    country_id: 36,
    country_code: "KH",
    country_name: "Cambodia",
  },
  {
    country_id: 37,
    country_code: "CM",
    country_name: "Cameroon",
  },
  {
    country_id: 38,
    country_code: "CA",
    country_name: "Canada",
  },
  {
    country_id: 39,
    country_code: "CV",
    country_name: "Cape Verde",
  },
  {
    country_id: 40,
    country_code: "KY",
    country_name: "Cayman Islands",
  },
  {
    country_id: 41,
    country_code: "CF",
    country_name: "Central African Republic",
  },
  {
    country_id: 42,
    country_code: "TD",
    country_name: "Chad",
  },
  {
    country_id: 43,
    country_code: "CL",
    country_name: "Chile",
  },
  {
    country_id: 44,
    country_code: "CN",
    country_name: "China",
  },
  {
    country_id: 45,
    country_code: "CX",
    country_name: "Christmas Island",
  },
  {
    country_id: 46,
    country_code: "CC",
    country_name: "Cocos (Keeling) Islands",
  },
  {
    country_id: 47,
    country_code: "CO",
    country_name: "Colombia",
  },
  {
    country_id: 48,
    country_code: "KM",
    country_name: "Comoros",
  },
  {
    country_id: 49,
    country_code: "CG",
    country_name: "Congo",
  },
  {
    country_id: 50,
    country_code: "CD",
    country_name: "Congo, The Democratic Republic of the",
  },
  {
    country_id: 51,
    country_code: "CK",
    country_name: "Cook Islands",
  },
  {
    country_id: 52,
    country_code: "CR",
    country_name: "Costa Rica",
  },
  {
    country_id: 53,
    country_code: "CI",
    country_name: "Cote D'Ivoire",
  },
  {
    country_id: 54,
    country_code: "HR",
    country_name: "Croatia",
  },
  {
    country_id: 55,
    country_code: "CU",
    country_name: "Cuba",
  },
  {
    country_id: 56,
    country_code: "CY",
    country_name: "Cyprus",
  },
  {
    country_id: 57,
    country_code: "CZ",
    country_name: "Czech Republic",
  },
  {
    country_id: 58,
    country_code: "DK",
    country_name: "Denmark",
  },
  {
    country_id: 59,
    country_code: "DJ",
    country_name: "Djibouti",
  },
  {
    country_id: 60,
    country_code: "DM",
    country_name: "Dominica",
  },
  {
    country_id: 61,
    country_code: "DO",
    country_name: "Dominican Republic",
  },
  {
    country_id: 62,
    country_code: "EC",
    country_name: "Ecuador",
  },
  {
    country_id: 63,
    country_code: "EG",
    country_name: "Egypt",
  },
  {
    country_id: 64,
    country_code: "SV",
    country_name: "El Salvador",
  },
  {
    country_id: 65,
    country_code: "GQ",
    country_name: "Equatorial Guinea",
  },
  {
    country_id: 66,
    country_code: "ER",
    country_name: "Eritrea",
  },
  {
    country_id: 67,
    country_code: "EE",
    country_name: "Estonia",
  },
  {
    country_id: 68,
    country_code: "ET",
    country_name: "Ethiopia",
  },
  {
    country_id: 69,
    country_code: "FK",
    country_name: "Falkland Islands (Malvinas)",
  },
  {
    country_id: 70,
    country_code: "FO",
    country_name: "Faroe Islands",
  },
  {
    country_id: 71,
    country_code: "FJ",
    country_name: "Fiji",
  },
  {
    country_id: 72,
    country_code: "FI",
    country_name: "Finland",
  },
  {
    country_id: 73,
    country_code: "FR",
    country_name: "France",
  },
  {
    country_id: 74,
    country_code: "GF",
    country_name: "French Guiana",
  },
  {
    country_id: 75,
    country_code: "PF",
    country_name: "French Polynesia",
  },
  {
    country_id: 76,
    country_code: "TF",
    country_name: "French Southern Territories",
  },
  {
    country_id: 77,
    country_code: "GA",
    country_name: "Gabon",
  },
  {
    country_id: 78,
    country_code: "GM",
    country_name: "Gambia",
  },
  {
    country_id: 79,
    country_code: "GE",
    country_name: "Georgia",
  },
  {
    country_id: 80,
    country_code: "DE",
    country_name: "Germany",
  },
  {
    country_id: 81,
    country_code: "GH",
    country_name: "Ghana",
  },
  {
    country_id: 82,
    country_code: "GI",
    country_name: "Gibraltar",
  },
  {
    country_id: 83,
    country_code: "GR",
    country_name: "Greece",
  },
  {
    country_id: 84,
    country_code: "GL",
    country_name: "Greenland",
  },
  {
    country_id: 85,
    country_code: "GD",
    country_name: "Grenada",
  },
  {
    country_id: 86,
    country_code: "GP",
    country_name: "Guadeloupe",
  },
  {
    country_id: 87,
    country_code: "GU",
    country_name: "Guam",
  },
  {
    country_id: 88,
    country_code: "GT",
    country_name: "Guatemala",
  },
  {
    country_id: 89,
    country_code: "GN",
    country_name: "Guinea",
  },
  {
    country_id: 90,
    country_code: "GW",
    country_name: "Guinea-Bissau",
  },
  {
    country_id: 91,
    country_code: "GY",
    country_name: "Guyana",
  },
  {
    country_id: 92,
    country_code: "HT",
    country_name: "Haiti",
  },
  {
    country_id: 93,
    country_code: "HM",
    country_name: "Heard Island and McDonald Islands",
  },
  {
    country_id: 94,
    country_code: "VA",
    country_name: "Holy See (Vatican City State)",
  },
  {
    country_id: 95,
    country_code: "HN",
    country_name: "Honduras",
  },
  {
    country_id: 96,
    country_code: "HK",
    country_name: "Hong Kong",
  },
  {
    country_id: 97,
    country_code: "HU",
    country_name: "Hungary",
  },
  {
    country_id: 98,
    country_code: "IS",
    country_name: "Iceland",
  },
  {
    country_id: 99,
    country_code: "IN",
    country_name: "India",
  },
  {
    country_id: 100,
    country_code: "ID",
    country_name: "Indonesia",
  },
  {
    country_id: 101,
    country_code: "IR",
    country_name: "Iran, Islamic Republic of",
  },
  {
    country_id: 102,
    country_code: "IQ",
    country_name: "Iraq",
  },
  {
    country_id: 103,
    country_code: "IE",
    country_name: "Ireland",
  },
  {
    country_id: 104,
    country_code: "IL",
    country_name: "Israel",
  },
  {
    country_id: 105,
    country_code: "IT",
    country_name: "Italy",
  },
  {
    country_id: 106,
    country_code: "JM",
    country_name: "Jamaica",
  },
  {
    country_id: 107,
    country_code: "JP",
    country_name: "Japan",
  },
  {
    country_id: 108,
    country_code: "JO",
    country_name: "Jordan",
  },
  {
    country_id: 109,
    country_code: "KZ",
    country_name: "Kazakhstan",
  },
  {
    country_id: 110,
    country_code: "KE",
    country_name: "Kenya",
  },
  {
    country_id: 111,
    country_code: "KI",
    country_name: "Kiribati",
  },
  {
    country_id: 112,
    country_code: "KP",
    country_name: "Korea, Democratic People's Republic of",
  },
  {
    country_id: 113,
    country_code: "KR",
    country_name: "Korea, Republic of",
  },
  {
    country_id: 114,
    country_code: "KW",
    country_name: "Kuwait",
  },
  {
    country_id: 115,
    country_code: "KG",
    country_name: "Kyrgyzstan",
  },
  {
    country_id: 116,
    country_code: "LA",
    country_name: "Lao People's Democratic Republic",
  },
  {
    country_id: 117,
    country_code: "LV",
    country_name: "Latvia",
  },
  {
    country_id: 118,
    country_code: "LB",
    country_name: "Lebanon",
  },
  {
    country_id: 119,
    country_code: "LS",
    country_name: "Lesotho",
  },
  {
    country_id: 120,
    country_code: "LR",
    country_name: "Liberia",
  },
  {
    country_id: 121,
    country_code: "LY",
    country_name: "Libyan Arab Jamahiriya",
  },
  {
    country_id: 122,
    country_code: "LI",
    country_name: "Liechtenstein",
  },
  {
    country_id: 123,
    country_code: "LT",
    country_name: "Lithuania",
  },
  {
    country_id: 124,
    country_code: "LU",
    country_name: "Luxembourg",
  },
  {
    country_id: 125,
    country_code: "MO",
    country_name: "Macao",
  },
  {
    country_id: 126,
    country_code: "MK",
    country_name: "Macedonia, The Former Yugoslav Republic of",
  },
  {
    country_id: 127,
    country_code: "MG",
    country_name: "Madagascar",
  },
  {
    country_id: 128,
    country_code: "MW",
    country_name: "Malawi",
  },
  {
    country_id: 129,
    country_code: "MY",
    country_name: "Malaysia",
  },
  {
    country_id: 130,
    country_code: "MV",
    country_name: "Maldives",
  },
  {
    country_id: 131,
    country_code: "ML",
    country_name: "Mali",
  },
  {
    country_id: 132,
    country_code: "MT",
    country_name: "Malta",
  },
  {
    country_id: 133,
    country_code: "MH",
    country_name: "Marshall Islands",
  },
  {
    country_id: 134,
    country_code: "MQ",
    country_name: "Martinique",
  },
  {
    country_id: 135,
    country_code: "MR",
    country_name: "Mauritania",
  },
  {
    country_id: 136,
    country_code: "MU",
    country_name: "Mauritius",
  },
  {
    country_id: 137,
    country_code: "YT",
    country_name: "Mayotte",
  },
  {
    country_id: 138,
    country_code: "MX",
    country_name: "Mexico",
  },
  {
    country_id: 139,
    country_code: "FM",
    country_name: "Micronesia, Federated States of",
  },
  {
    country_id: 140,
    country_code: "MD",
    country_name: "Moldova, Republic of",
  },
  {
    country_id: 141,
    country_code: "MC",
    country_name: "Monaco",
  },
  {
    country_id: 142,
    country_code: "MN",
    country_name: "Mongolia",
  },
  {
    country_id: 143,
    country_code: "MS",
    country_name: "Montserrat",
  },
  {
    country_id: 144,
    country_code: "MA",
    country_name: "Morocco",
  },
  {
    country_id: 145,
    country_code: "MZ",
    country_name: "Mozambique",
  },
  {
    country_id: 146,
    country_code: "MM",
    country_name: "Myanmar",
  },
  {
    country_id: 147,
    country_code: "NA",
    country_name: "Namibia",
  },
  {
    country_id: 148,
    country_code: "NR",
    country_name: "Nauru",
  },
  {
    country_id: 149,
    country_code: "NP",
    country_name: "Nepal",
  },
  {
    country_id: 150,
    country_code: "NL",
    country_name: "Netherlands",
  },
  {
    country_id: 151,
    country_code: "AN",
    country_name: "Netherlands Antilles",
  },
  {
    country_id: 152,
    country_code: "NC",
    country_name: "New Caledonia",
  },
  {
    country_id: 153,
    country_code: "NZ",
    country_name: "New Zealand",
  },
  {
    country_id: 154,
    country_code: "NI",
    country_name: "Nicaragua",
  },
  {
    country_id: 155,
    country_code: "NE",
    country_name: "Niger",
  },
  {
    country_id: 156,
    country_code: "NG",
    country_name: "Nigeria",
  },
  {
    country_id: 157,
    country_code: "NU",
    country_name: "Niue",
  },
  {
    country_id: 158,
    country_code: "NF",
    country_name: "Norfolk Island",
  },
  {
    country_id: 159,
    country_code: "MP",
    country_name: "Northern Mariana Islands",
  },
  {
    country_id: 160,
    country_code: "NO",
    country_name: "Norway",
  },
  {
    country_id: 161,
    country_code: "OM",
    country_name: "Oman",
  },
  {
    country_id: 162,
    country_code: "PK",
    country_name: "Pakistan",
  },
  {
    country_id: 163,
    country_code: "PW",
    country_name: "Palau",
  },
  {
    country_id: 164,
    country_code: "PS",
    country_name: "Palestinian Territory, Occupied",
  },
  {
    country_id: 165,
    country_code: "PA",
    country_name: "Panama",
  },
  {
    country_id: 166,
    country_code: "PG",
    country_name: "Papua New Guinea",
  },
  {
    country_id: 167,
    country_code: "PY",
    country_name: "Paraguay",
  },
  {
    country_id: 168,
    country_code: "PE",
    country_name: "Peru",
  },
  {
    country_id: 169,
    country_code: "PH",
    country_name: "Philippines",
  },
  {
    country_id: 170,
    country_code: "PN",
    country_name: "Pitcairn",
  },
  {
    country_id: 171,
    country_code: "PL",
    country_name: "Poland",
  },
  {
    country_id: 172,
    country_code: "PT",
    country_name: "Portugal",
  },
  {
    country_id: 173,
    country_code: "PR",
    country_name: "Puerto Rico",
  },
  {
    country_id: 174,
    country_code: "QA",
    country_name: "Qatar",
  },
  {
    country_id: 175,
    country_code: "RE",
    country_name: "Reunion",
  },
  {
    country_id: 176,
    country_code: "RO",
    country_name: "Romania",
  },
  {
    country_id: 177,
    country_code: "RU",
    country_name: "Russian Federation",
  },
  {
    country_id: 178,
    country_code: "RW",
    country_name: "Rwanda",
  },
  {
    country_id: 179,
    country_code: "SH",
    country_name: "Saint Helena",
  },
  {
    country_id: 180,
    country_code: "KN",
    country_name: "Saint Kitts and Nevis",
  },
  {
    country_id: 181,
    country_code: "LC",
    country_name: "Saint Lucia",
  },
  {
    country_id: 182,
    country_code: "PM",
    country_name: "Saint Pierre and Miquelon",
  },
  {
    country_id: 183,
    country_code: "VC",
    country_name: "Saint Vincent and the Grenadines",
  },
  {
    country_id: 184,
    country_code: "WS",
    country_name: "Samoa",
  },
  {
    country_id: 185,
    country_code: "SM",
    country_name: "San Marino",
  },
  {
    country_id: 186,
    country_code: "ST",
    country_name: "Sao Tome and Principe",
  },
  {
    country_id: 187,
    country_code: "SA",
    country_name: "Saudi Arabia",
  },
  {
    country_id: 188,
    country_code: "SN",
    country_name: "Senegal",
  },
  {
    country_id: 189,
    country_code: "CS",
    country_name: "Serbia and Montenegro",
  },
  {
    country_id: 190,
    country_code: "SC",
    country_name: "Seychelles",
  },
  {
    country_id: 191,
    country_code: "SL",
    country_name: "Sierra Leone",
  },
  {
    country_id: 192,
    country_code: "SG",
    country_name: "Singapore",
  },
  {
    country_id: 193,
    country_code: "SK",
    country_name: "Slovakia",
  },
  {
    country_id: 194,
    country_code: "SI",
    country_name: "Slovenia",
  },
  {
    country_id: 195,
    country_code: "SB",
    country_name: "Solomon Islands",
  },
  {
    country_id: 196,
    country_code: "SO",
    country_name: "Somalia",
  },
  {
    country_id: 197,
    country_code: "ZA",
    country_name: "South Africa",
  },
  {
    country_id: 198,
    country_code: "GS",
    country_name: "South Georgia and the South Sandwich Islands",
  },
  {
    country_id: 199,
    country_code: "ES",
    country_name: "Spain",
  },
  {
    country_id: 200,
    country_code: "LK",
    country_name: "Sri Lanka",
  },
  {
    country_id: 201,
    country_code: "SD",
    country_name: "Sudan",
  },
  {
    country_id: 202,
    country_code: "SR",
    country_name: "Suriname",
  },
  {
    country_id: 203,
    country_code: "SJ",
    country_name: "Svalbard and Jan Mayen",
  },
  {
    country_id: 204,
    country_code: "SZ",
    country_name: "Swaziland",
  },
  {
    country_id: 205,
    country_code: "SE",
    country_name: "Sweden",
  },
  {
    country_id: 206,
    country_code: "CH",
    country_name: "Switzerland",
  },
  {
    country_id: 207,
    country_code: "SY",
    country_name: "Syrian Arab Republic",
  },
  {
    country_id: 208,
    country_code: "TW",
    country_name: "Taiwan",
  },
  {
    country_id: 209,
    country_code: "TJ",
    country_name: "Tajikistan",
  },
  {
    country_id: 210,
    country_code: "TZ",
    country_name: "Tanzania, United Republic of",
  },
  {
    country_id: 211,
    country_code: "TH",
    country_name: "Thailand",
  },
  {
    country_id: 212,
    country_code: "TL",
    country_name: "Timor-Leste",
  },
  {
    country_id: 213,
    country_code: "TG",
    country_name: "Togo",
  },
  {
    country_id: 214,
    country_code: "TK",
    country_name: "Tokelau",
  },
  {
    country_id: 215,
    country_code: "TO",
    country_name: "Tonga",
  },
  {
    country_id: 216,
    country_code: "TT",
    country_name: "Trinidad and Tobago",
  },
  {
    country_id: 217,
    country_code: "TN",
    country_name: "Tunisia",
  },
  {
    country_id: 218,
    country_code: "TR",
    country_name: "Turkey",
  },
  {
    country_id: 219,
    country_code: "TM",
    country_name: "Turkmenistan",
  },
  {
    country_id: 220,
    country_code: "TC",
    country_name: "Turks and Caicos Islands",
  },
  {
    country_id: 221,
    country_code: "TV",
    country_name: "Tuvalu",
  },
  {
    country_id: 222,
    country_code: "UG",
    country_name: "Uganda",
  },
  {
    country_id: 223,
    country_code: "UA",
    country_name: "Ukraine",
  },
  {
    country_id: 224,
    country_code: "AE",
    country_name: "United Arab Emirates",
  },
  {
    country_id: 225,
    country_code: "GB",
    country_name: "United Kingdom",
  },
  {
    country_id: 226,
    country_code: "US",
    country_name: "United States",
  },
  {
    country_id: 227,
    country_code: "UM",
    country_name: "United States Minor Outlying Islands",
  },
  {
    country_id: 228,
    country_code: "UY",
    country_name: "Uruguay",
  },
  {
    country_id: 229,
    country_code: "UZ",
    country_name: "Uzbekistan",
  },
  {
    country_id: 230,
    country_code: "VU",
    country_name: "Vanuatu",
  },
  {
    country_id: 231,
    country_code: "VE",
    country_name: "Venezuela",
  },
  {
    country_id: 232,
    country_code: "VN",
    country_name: "Viet Nam",
  },
  {
    country_id: 233,
    country_code: "VG",
    country_name: "Virgin Islands, British",
  },
  {
    country_id: 234,
    country_code: "VI",
    country_name: "Virgin Islands, U.S.",
  },
  {
    country_id: 235,
    country_code: "WF",
    country_name: "Wallis and Futuna",
  },
  {
    country_id: 236,
    country_code: "EH",
    country_name: "Western Sahara",
  },
  {
    country_id: 237,
    country_code: "YE",
    country_name: "Yemen",
  },
  {
    country_id: 238,
    country_code: "ZM",
    country_name: "Zambia",
  },
  {
    country_id: 239,
    country_code: "ZW",
    country_name: "Zimbabwe",
  },
];
